// Dibuja un gráfico de Chart.js en un canvas fuera de pantalla y lo devuelve como PNG, para
// meterlo en el PDF exportado.
//
// POR QUÉ NO SE CAPTURAN LOS GRÁFICOS DE LA PANTALLA
// Antes el PDF copiaba el canvas de los gráficos montados vía refs. Pero solo están montados los
// de la pestaña activa: al exportar "Todos" desde General, las secciones de Ocupación, Resultados
// o Tendencias salían sin imagen, y cuando un componente se reemplazaba (el donut de canal, por
// ejemplo) su ref quedaba colgando. Dibujar desde los datos no depende de qué pestaña se está
// mirando ni de cómo esté armada la pantalla.
import Chart from 'chart.js/auto';

// Fondo blanco explícito: un PNG con fondo transparente se ve negro en algunos visores de PDF.
const pluginFondoBlanco = {
    id: 'fondoBlancoExportacion',
    beforeDraw: (chart) => {
        const { ctx, width, height } = chart;
        ctx.save();
        ctx.globalCompositeOperation = 'destination-over';
        ctx.fillStyle = '#ffffff';
        ctx.fillRect(0, 0, width, height);
        ctx.restore();
    },
};

/**
 * @param {{tipo: string, data: object, options?: object, ancho?: number, alto?: number}} definicion
 *        Configuración de Chart.js (armada en exportacionTablas.js) más el tamaño en px.
 * @returns {string|null} data URL PNG, o null si el entorno no puede dibujar (sin canvas).
 */
export function imagenGrafico(definicion) {
    if (!definicion || typeof document === 'undefined') return null;
    const ancho = definicion.ancho || 1000;
    const alto = definicion.alto || 440;
    const canvas = document.createElement('canvas');
    canvas.width = ancho;
    canvas.height = alto;
    let contexto = null;
    try {
        contexto = canvas.getContext('2d');
    } catch (e) {
        return null;
    }
    if (!contexto) return null;

    let grafico = null;
    try {
        const opciones = definicion.options || {};
        grafico = new Chart(contexto, {
            type: definicion.tipo,
            data: definicion.data,
            options: {
                ...opciones,
                // Sin animación ni responsive: el PNG se toma apenas se crea el gráfico, sobre el
                // tamaño fijo del canvas.
                responsive: false,
                maintainAspectRatio: false,
                animation: false,
                devicePixelRatio: 1,
                plugins: {
                    ...(opciones.plugins || {}),
                    tooltip: { enabled: false },
                },
            },
            plugins: [pluginFondoBlanco],
        });
        // JPEG y no PNG: con ~20 gráficos el PDF en PNG pesaba más de 20 MB. Con el fondo blanco
        // de arriba no hay transparencia que perder y el tamaño baja a una fracción.
        return canvas.toDataURL('image/jpeg', 0.9);
    } catch (e) {
        console.error('No se pudo dibujar el gráfico para la exportación:', e);
        return null;
    } finally {
        if (grafico) grafico.destroy();
    }
}
